import React, { FC } from 'react';
import { Alert, Box, Divider } from '@mui/material';
import { ActionSet } from 'models/action-set';
import ManageActions from './manage-actions/manage-actions.component';
import TeethSelection, {
    SelectionMode,
} from 'components/order-flow/shared/constructions/teeth-selection/teeth-selection.component';
import ConstructionProperties from './construction-properties/construction-properties.component';
import { ActionConstruction } from 'models/order-input/action-order';
import { useConstructions } from 'context/construction-context';

type ConstructionFormProps = {
    construction?: ActionConstruction;
    actionSet: ActionSet;
    onConstructionChanged?: (construction: ActionConstruction, isValid: boolean) => void;
};
const ConstructionForm: FC<ConstructionFormProps> = ({ actionSet }) => {
    const {
        construction,
        primaryAction,
        subCategoryId,
        aggregatedTeethOption,
        handleTeethSelectionChanged,
        handleActionsChanged,
    } = useConstructions();

    const teethSelectionType = () => {
        switch (aggregatedTeethOption) {
            case 'Single tooth':
                return SelectionMode.SINGLE;
            case 'Range':
                return SelectionMode.RANGE;
            case 'Up/low jaw':
                return SelectionMode.JAW;
            default:
                return SelectionMode.SINGLE;
        }
    };

    return (
        <>
            {primaryAction.notes ? (
                <Box mb={2}>
                    <Alert severity="warning">{primaryAction.notes}</Alert>
                </Box>
            ) : undefined}

            <Box>
                <ManageActions
                    actionSet={actionSet}
                    actions={construction.actions}
                    subCategoryId={subCategoryId}
                    onActionsChanged={handleActionsChanged}
                />
            </Box>

            <Box mt={2} mb={4}>
                <Divider />
            </Box>

            {aggregatedTeethOption ? (
                <Box mb={2} width={1200}>
                    <TeethSelection
                        teeth={construction.teethNumbers}
                        teethRange={construction.teethRange}
                        onChange={handleTeethSelectionChanged}
                        selectionMode={teethSelectionType()}
                    />
                </Box>
            ) : undefined}

            <Box mb={2}>
                <ConstructionProperties />
            </Box>
        </>
    );
};

export default ConstructionForm;
